import { render, staticRenderFns } from "./HistoricalMerchantCount.vue?vue&type=template&id=3620e982&"
import script from "./HistoricalMerchantCount.vue?vue&type=script&lang=ts&"
export * from "./HistoricalMerchantCount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "HistoricalMerchantCount.vue"
export default component.exports